module.exports = __webpack_public_path__ + "static/img/liyade5.bab59126.jpg";